import get from 'lodash/get';

const Attribute = {
  props: {
    product: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    attribute: {
      type: Array,
      required: true,
    },
    initAttributeSelection: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    /**
     * Get human label for finish attribute.
     * @return {*}
     */
    currentFinishLabel() {
      const finishMetaData = this.product.categorizationHierarchyMetadata.find(
        (item) => item.code === 'specFinishLabel'
      );
      return get(finishMetaData, 'options.displayName', '');
    },
  },
  methods: {
    productSelected(options = {}) {
      this.currentFinishValue = get(options, 'specFinishTranslated', '');
      this.$emit('product-selected', options);
    },
  },
  data() {
    return {
      currentFinishValue: '',
    };
  },
};

export {Attribute};
